import React from 'react';
// import PropTypes from 'prop-types';
import { notification, Icon } from 'antd';
import './index.scss';

const duration = 2

notification.oldSuccess = notification.success;
notification.success = function(config){
    let defaultConf = {
        icon: <Icon type="check-circle" />,
        duration: duration
    };
    typeof config === 'string' ? defaultConf.description = config : Object.assign(defaultConf, config);
    defaultConf.className = config.className  ? "u_notification_success " + config.className : "u_notification_success" 
    return this.oldSuccess(defaultConf);
}

notification.oldInfo = notification.info;
notification.info =  function(config){
    let defaultConf = {
        icon: <Icon type="info-circle" />,
        duration: duration
    };
    typeof config === 'string' ? defaultConf.description = config : Object.assign(defaultConf, config);
    defaultConf.className = config.className  ? "u_notification_info " + config.className : "u_notification_info" 
    return this.oldInfo(defaultConf);
}

notification.oldError = notification.error;
notification.error = function(config){
    let defaultConf = {
        icon: <Icon type="exclamation-circle" />,
        duration: duration
    };
    typeof config === 'string' ? defaultConf.description = config : Object.assign(defaultConf, config);
    defaultConf.className = config.className  ? "u_notification_error " + config.className : "u_notification_error" 
    return this.oldError(defaultConf);
}

export default notification


// WEBPACK FOOTER //
// ./src/components/Notification/index.js